import requests from "./httpService";

const BrandServices = {

    getBrand: async () =>{
        return requests.get(`/brand`);
    },
    getBrandByType: async (data) =>{
        return requests.get(`/brand/type/${data}`);
    },
    updateBrand : async (id,body) =>{
      
        return requests.patch(`/brand/${id}`,body);
    },

    createBrand : async (body) =>{
      
        return requests.post(`/brand`,body);
    },
    deleteBrand : async (id) =>{
        return requests.delete(`/brand/${id}`);
    },
  
    purchasereport: async () =>{
        return requests.get(`/purchase/report`);
    },

}
export default BrandServices;